// frontend/src/components/AuctionBanner.js
//
// A thin gold bar across the members' app and the public website while the
// Super Series auction is live ("Watch live") and for 14 days after it ends
// ("See the squads"). Checks /api/public/auction/status once a minute — a
// tiny call, so it costs nothing when no auction is on.

import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const DISMISS_KEY = 'ucc_auction_banner_dismissed';

export default function AuctionBanner() {
  const [st, setSt] = useState(null);
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) || ''; } catch { return ''; }
  });

  useEffect(() => {
    let alive = true;
    const load = () => api.get('/public/auction/status')
      .then(r => { if (alive) setSt(r.data?.auction || null); })
      .catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!st) return null;
  const live = st.status === 'live';
  // A finished auction's banner can be closed; a live one always shows.
  if (!live && hidden === st.id) return null;

  return (
    <div style={{ background: live ? '#B91C1C' : '#F5C518', color: live ? 'white' : '#0F1E38',
                  display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', fontSize: '0.85rem', fontWeight: 700 }}>
      <span style={{ flex: 1 }}>
        {live ? `🔴 ${st.series_name} auction is LIVE` : `🏆 ${st.series_name} auction complete — see the squads`}
      </span>
      <a href="/auction/live" style={{ background: live ? 'white' : '#1E3A6E', color: live ? '#B91C1C' : 'white', borderRadius: 6,
                                       padding: '4px 12px', textDecoration: 'none', fontFamily: 'Rajdhani, sans-serif', fontWeight: 700 }}>
        {live ? 'Watch live' : 'See squads'}
      </a>
      {!live && (
        <button aria-label="Close" onClick={() => { setHidden(st.id); try { localStorage.setItem(DISMISS_KEY, st.id); } catch { /* ignore */ } }}
                style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#0F1E38', lineHeight: 1 }}>×</button>
      )}
    </div>
  );
}
